import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { SavePageComponent } from './save.component';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: SavePageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class SavePageRoutingModule {}
